<div class="container">
    <div class="p-4 shadow-lg mb-3 rounded">
        <div>
            <label appNgDropFiles class="form-group file-upload-wrapper well drop-zone" [files]="files"
                (detectDrop)="cargar()" [acceptFile]="filesType" [multiple]="multiple" [maxSize]="maxSize" [scale]="scale"
                [ngClass]="{ 'file-over': estaSobreElemento }" (mouseSobre)="estaSobreElemento = $event" for="upload">
                <span class="fa fa-folder-open" aria-hidden="true">Seleccione o arraste
                    {{ (multiple) ? 'los archivos' : 'el archivo' }} aquí</span>
                <input type="file" id="upload" style="display:none" size="2048" [accept]="accept()"
                    name="files" (change)="changeFiles($event.target?.files)" [multiple]="multiple">
            </label>
        </div>
        <div class="alert alert-danger text-center" role="alert" *ngIf="mostrar">
            Debe seleccionar {{ (multiple) ? 'al menos' : '' }} un archivo
        </div>
        <div *ngIf="files.length > 0" class="border m-1 rounded">
            <div class="centerText">
                <b>Archivo{{ (multiple) ? 's' : '' }} por cargar</b>
            </div>
            <div class="row" *ngFor="let file of files; let i = index">
                <div class="col-2 centerText">{{ i + 1 }}</div>
                <div class="col-6"><i class="fa fa-file{{ checkType(file.type) }}"></i>&nbsp;{{ file.name }}
                </div>
                <div class="col-2" style="padding: 0px">{{ file.size | filesize }}</div>
                <div class="col-1" (click)="eliminaImg(i)"><i class="fa fa-trash"></i></div>
            </div>
        </div>
        <div style="text-align: center;" *ngIf="modalEmpty()">
            <button [disabled]="files.length === 0" class="btn btn-success text-uppercase font-weight-bold" (click)="modalSave()">
                <i class="fa fa-check-circle-o" aria-hidden="true"></i> Cargar
            </button>&nbsp;&nbsp;
            <button class="btn btn-secondary text-uppercase font-weight-bold" (click)="activeModal.close()">
                <i class="fa fa-times-circle-o" aria-hidden="true"></i> Cerrar
            </button>
        </div>
    </div>
</div>